import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ConfidenceCheckManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/confidence-check")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ConfidenceCheckManagement />
    </RouteGuard>
  ),
});
